export const GET_ITEM_MAPPINGS_REQUESTED =
  'GET_ITEM_MAPPINGS_REQUESTED'
export const GET_ITEM_MAPPINGS_SUCCEEDED =
  'GET_ITEM_MAPPINGS_SUCCEEDED'
export const GET_ITEM_MAPPINGS_FAILED = 'GET_ITEM_MAPPINGS_FAILED'

export const REMOVE_ITEM_MAPPING_REQUESTED =
  'REMOVE_ITEM_MAPPING_REQUESTED'

export const REMOVE_ITEM_MAPPING_SUCCEEDED =
  'REMOVE_ITEM_MAPPING_SUCCEEDED'

export const REMOVE_ITEM_MAPPING_FAILED = 'REMOVE_ITEM_MAPPING_FAILED'

export const UPDATE_ITEM_MAPPING_REQUESTED =
  'UPDATE_ITEM_MAPPING_REQUESTED'
export const UPDATE_ITEM_MAPPING_SUCCEEDED =
  'UPDATE_ITEM_MAPPING_SUCCEEDED'
export const UPDATE_ITEM_MAPPING_FAILED = 'UPDATE_ITEM_MAPPING_FAILED'

export const CREATE_ITEM_MAPPING_REQUESTED =
  'CREATE_ITEM_MAPPING_REQUESTED'
export const CREATE_ITEM_MAPPING_SUCCEEDED =
  'CREATE_ITEM_MAPPING_SUCCEEDED'
export const CREATE_ITEM_MAPPING_FAILED = 'CREATE_ITEM_MAPPING_FAILED'
